import React, { forwardRef, useImperativeHandle, useState } from "react";
import { Button, Modal } from "rsuite";

const ConfirmationModal = forwardRef((props, ref) => {
  const {
    open,
    onClose,
    onCancel,
    onConfirm,
    onProceed,
    title = "Confirmation",
    message,
    body,
    children,
    confirmText = "Proceed",
    cancelText = "Cancel",
    confirmAppearance = "primary",
    cancelAppearance = "subtle",
    size = "xs",
    loading = false,
    confirmLoading = false,
    className = "",
    style = {},
    backdropStyle = {},
    bodyClassName = "",
    ...rest
  } = props;

  const [internalOpen, setInternalOpen] = useState(false);
  const isControlled = open !== undefined;
  const isOpen = isControlled ? open : internalOpen;

  useImperativeHandle(ref, () => ({
    openModal: () => setInternalOpen(true),
    closeModal: () => setInternalOpen(false),
  }));

  const handleCancel = (e) => {
    if (!isControlled) {
      setInternalOpen(false);
    }
    if (onCancel) {
      onCancel(e);
    } else if (onClose) {
      onClose(e);
    }
  };

  const handleConfirm = async (e) => {
    if (!isControlled) {
      setInternalOpen(false);
    }
    if (onConfirm) {
      await onConfirm(e);
    } else if (onProceed) {
      await onProceed(e);
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleCancel}
      size={size}
      className={`confirmation-modal ${className}`.trim()}
      style={{
        zIndex: 1070,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
      }}
      backdropStyle={{
        zIndex: 1060,
        ...backdropStyle,
      }}
      {...rest}
    >
      {title && (
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body className={bodyClassName}>
        {message || body || children}
      </Modal.Body>
      <Modal.Footer>
        {cancelText && (
          <Button
            appearance={cancelAppearance}
            onClick={handleCancel}
          >
            {cancelText}
          </Button>
        )}
        {confirmText && (
          <Button
            appearance={confirmAppearance}
            onClick={handleConfirm}
            loading={loading || confirmLoading}
          >
            {confirmText}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
});

export default ConfirmationModal;
